/**
 * Checks if a value is a valid number.
 * @param {any} n - Value to check.
 * @returns {boolean} - True if the value is a number, false otherwise.
 */
export function isNumber(n: any): boolean {
    return !isNaN(+n) && isFinite(n);
}